import { Component, ElementRef, forwardRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';
import { UntypedFormControl,NG_VALUE_ACCESSOR,Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import _ from 'lodash';
import { CommonModule } from '@angular/common';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { IconDeleteChipsComponent } from 'app/icon/components/icon-delete-chips/icon-delete-chips.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';


@Component({
  standalone: true,
  selector: 'app-chips-autocomplete',
  templateUrl: './chips-autocomplete.component.html',
  styleUrls: ['./chips-autocomplete.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconDeleteChipsComponent,
    MdbFormsModule,
    MdbAutocompleteModule
  ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ChipsAutocompleteComponent),
    multi: true,
  }]
})
export class ChipsAutocompleteComponent implements OnInit {
  searchText = new Subject<string>();
  results: Observable<string[]>;
  notFound = false;
  @ViewChild('chipsAutocomplete', { static: false }) chipsAutocomplete: ElementRef; 
  listSet: any;  
  list: string[] = []; 
  
  @Input() elementPattern = /.+/;
  @Input() label = "New Element...";
  @Input() required = false;
  @Input() touched = false; 
  @Input() optCategories = []

  public isShowPromp = true

  public control: UntypedFormControl = null;
  private onChangeCallback = (value: any) => {};
  private onTouchedCallback = () => {};

  constructor() {
    this.control = new UntypedFormControl('', []);
    this.results = this.searchText.pipe(
      startWith(''),
      map((value: string) => {
        this.listSet = value

        return this.filter(value)  
      }),
      tap((results: string[]) => {
        results.length > 0 ? (this.notFound = false) : (this.notFound = true)
      }
      )
    );
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouchedCallback = fn;
  }

   writeValue(list: string[]) {
    this.list = list;
  }

   filter(value): string[] {
    const filterValue = value.toLowerCase();
    const list = _.difference(this.optCategories, this.list);
    return list.filter((item: string) =>
      item.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit(): void {
    if(this.required) {
      this.control.setValidators([Validators.required]);
    }
    this.list = this.control.value
  }

  ngOnChanges(changes: SimpleChanges): void {
    const touched = _.get(changes, 'touched.currentValue', this.touched);
    if(touched) {
      this.control.markAsTouched();
    } else {
      this.control.markAsUntouched();
    }
  }

  onOptionsSetKeydown() {
    this.chipsAutocomplete.nativeElement.classList.remove('focused')
    this.chipsAutocomplete.nativeElement.blur()
    this.isShowPromp = false

    let value = this.listSet.trim()  
    this.chipsAutocomplete.nativeElement.value = ''
    if(value.match(this.elementPattern)) {
      const found = _.find(this.list, (element) => {
        this.listSet = ''
        this.chipsAutocomplete.nativeElement.value = ''
        return _.isEqual(_.toLower(element), _.toLower(value));
      }) || false;
      if(found === false) {
        this.list.push(value);
        this.chipsAutocomplete.nativeElement.value = ''
      }
    }
    this.searchText.next('');
    
    if (this.listSet == "" || this.listSet == null) return;  
    this.onChangeCallback(this.list);
    this.listSet = " ";   
  }  
  
  dropOptionChips(index: any) { 
    this.list.splice(index, 1);  
    this.onChangeCallback(this.list);
    
    this.searchText.next('');
    this.listSet = ""; 
  }  
}
